const style = {
  row: {
    marginTop: `32px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/row.js